export const coursesSelector = (state: any) => state.courses;
